import { makeAutoObservable, runInAction } from "mobx";

class FullScreenModalStore {
	data = {
		show: false,
		type: "",
    size: "",
		data: {}
	}
  constructor() {
		makeAutoObservable(this)
  }

	setData(n) {
		if(!n) return
		runInAction(() => {
			this.data = {
				...this.data,
				...n
			}
      // console.log("this.data", this.data);
		})
	}

  async updateData(res, cid) {
    const {
      tool,
      event,
      msg_id,
    } = res;
    const {
      share_url,
      url,
      title,
      content,
    } = event;
    let output = {}

    if (tool === 'pdf') {
      output = {
        show: true, 
        type: "pdf",
        data: {
          shareUrl: share_url || url,
          url,
          fileName: title,
        }
      }
    } else if (tool === 'mindmap') {
      let text = content;
      if (!text && /^http/i.test(url)) {
        text = await fetch(url).then(res => res.text()).catch(_ => '');
      }
      output = {
        show: true, 
        type: "mindmap",
        data: {
          shareUrl: share_url,
          url,
          title: title,
          content: text,
        }
      }
    } else if (tool === 'html') {
      let shareId;
      const params = new URLSearchParams(share_url);
      const id = params.get('id');
      if (id) {
        shareId = id;
      } else {
        if (/^https\:\/\/(\w{6,})\.n\.cn/.test(share_url)) {
          shareId = RegExp.$1;
        }
      }
      output = {
        show: true, 
        type: "html",
        data: {
          shareUrl: share_url,
          shareId: shareId,
          content: content,
          noDownload: true
        }
      }
    } else if (tool === 'ppt_html') {
      let shareId;
      const params = new URLSearchParams(share_url);
      const id = params.get('id');
      if (id) {
        shareId = id;
      } else {
        if (/^https\:\/\/(\w{6,})\.n\.cn/.test(share_url)) {
          shareId = RegExp.$1;
        }
      }
      output = {
        show: true, 
        type: "ppt",
        data: {
          shareUrl: share_url || url,
          contents: event.contents,
          urls: event.urls || [],
          shareId: shareId,
          chatId: cid,
          msg_id: msg_id
        }
      }
    } else if (tool === 'text') {
      let text = content;
      if (!text && /^http/i.test(url)) {
        text = await fetch(url).then(res => res.text()).catch(_ => '');
      }
      output = {
        show: true, 
        type: "markdown",
        data: {
          shareUrl: share_url,
          url,
          content: text,
          fileName: title,
        }
      }
    }

    this.setData(output)
  }
}

const fullScreenModalStore = new FullScreenModalStore()
window.fullScreenModalStore = fullScreenModalStore;
export default fullScreenModalStore